export const ARCHIVED_ACTIONS = {
  Archive: 'archive',
  Restore: 'restore'
};
